import type { IAuthProps } from '../Auth/Auth'

import Auth from '../Auth/Auth'

import styles from './AuthPage.css'

interface IProps extends IAuthProps {
  readonly title: string
}

/**
 * Az Auth komponensre épülő teljes bejelentkezési felület.
 * Minden admin és egyéb oldalunkon ezt használuk, ahol van bejelentkezés.
 * @param props - JSX props {@link IProps}.
 */
export default function AuthPage (props: IProps): HTMLElement {
  const { title, ...authProps } = props

  return (
    <div className="auth-page">
      <div className="auth-page__logo" />
      <div className="auth-page__title">{ title }</div>

      <div className={ styles.authPageWindow }>
        <Auth { ...authProps } />
      </div>
    </div>
  )
}
